import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Import your images
import transactionSuccesfull from "../../../assests/transactionSuccesfull.png";
import transactionFailed from "../../../assests/transactionFailed.png";
import transactionPending from "../../../assests/transactionPending.png";
import { RiShareBoxLine } from "react-icons/ri";

export const TransactionStatus = ({
  imageSrc,
  title,
  message,
  transactionId,
  buttonText,
  buttonClick,
  paymentLink,
  role,
}) => {
  const navigate = useNavigate();

  const [timer, setTimer] = useState(20);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      if (role === "company") {
        navigate("/company/settings");
      } else {
        window.open("https://user.reaidy.io", "_self");
      }
    }
  }, [timer, navigate]);

  return (
    <div className="bg-white items-center justify-center tc1:gap-8  h-screen w-screen">
      <div className="bg-white md:flex md:flex-row tc1:flex tc1:flex-col tc1:-mt-6 md:mt-0 items-center justify-center md:gap-16 tc1:gap-8 h-screen w-screen w-full">
        <div className="relative">
          <img
            src={imageSrc}
            alt={title}
            className="md:w-64 md:h-w-64 tc1:w-40 tc1:h-w-40 "
          />
        </div>

        <div className="items-center justify-center tc1:px-5 md:pl-0">
          <h2 className="md:text-3xl tc1:text-2xl font-semibold whitespace-nowrap mb-4">
            {title}
          </h2>
          <p className="text-gray-800 text-lg  font-medium">{message}</p>
          <p className="text-gray-800 text-lg mt-3  font-medium">
            Transaction ID :{" "}
            <span className="text-primary font-semibold">{transactionId}</span>
          </p>
          {/* {paymentLink !== "" && (
            <a
              className={`mt-7 text-white bg-yellow-400 w-fit p-3 py-2 rounded-lg font-semibold gap-3 text-lg flex items-center justify-start`}
              href={paymentLink}
            >
              Retry Payment Now
            </a>
          )} */}

          <button
            className={`mt-7 text-primary font-semibold gap-3 text-lg flex items-center justify-center`}
            onClick={buttonClick}
          >
            {buttonText} <RiShareBoxLine />
          </button>
        </div>
      </div>

      <div className="w-[full] md:-mt-60 tc1:-mt-44 flex items-center justify-center">
        <div className="md:w-[22%] rounded-lg px-8 py-2">
          <p className="text-gray-800 whitespace-nowrap md:text-sm tc1:text-xs">
            Re-directing to{" "}
            <span
              className="text-primary cursor-pointer underline whitespace-nowrap"
              onClick={() => {
                if (role === "company") {
                  navigate("/company/settings");
                } else {
                  window.open("https://user.reaidy.io", "_self");
                }
              }}
            >
              home page
            </span>{" "}
            in{" "}
            <span
              className="text-primary"
              onClick={() => {
                if (role === "company") {
                  navigate("/company/settings");
                } else {
                  window.open("https://user.reaidy.io", "_self");
                }
              }}
            >
              {timer}
            </span>{" "}
            seconds
          </p>
        </div>
      </div>
    </div>
  );
};

const TransactionCards = (props) => {
  // create a react state for plan name
  const [planName, setPlanName] = useState("Plan");
  const [paymentLink, setPaymentLink] = useState("");
  const [transactionId, setTransactionId] = useState("Plan");
  const navigate = useNavigate();
  const URL = window.location.href;
  const isCompany = URL.includes("company") ? true : false;
  const role = new URLSearchParams(window.location.search).get("role");
  // create a react state for status

  // take plan name from url params and set it to plan name state
  useEffect(() => {
    try {
      const paymentLink = new URLSearchParams(window.location.search).get(
        "paymentLink"
      );
      if (paymentLink) {
        setPaymentLink(paymentLink ?? "");
      }
      const planName = new URLSearchParams(window.location.search).get(
        "planName"
      );
      console.log(planName);
      setPlanName(planName);
    } catch (error) {
      console.log(error);
      setPlanName("Plan");
    }

    try {
      //create the transaction id
      const transactionId = new URLSearchParams(window.location.search).get(
        "transactionId"
      );
      setTransactionId(transactionId);
      console.log(transactionId);
    } catch (error) {
      console.log(error);
      setTransactionId("Plan");
    }
  }, []);

  return (
    <div className="flex flex-col items-center justify-center  bg-gray-100">
      {/* <h1 className="text-3xl font-bold mb-8">Transaction Statuses</h1> */}

      <div className="">
        {props.status === "success" ? (
          <TransactionStatus
            status="success"
            imageSrc={transactionSuccesfull}
            paymentLink={paymentLink}
            title={<p className="text-green-500"> Transaction Successful! </p>}
            message={
              <>
                <p className="block tc1:hidden lg:block">
                  Your{" "}
                  {/* <span className="text-primary font-semibold ">
                    {planName}
                  </span>{" "} */}
                  order is now active. <br /> Get ready to streamline your
                  hiring with Reaidy.io!
                </p>
                <p className="hidden tc1:block">
                  Your{" "}
                  {/* <span className="text-primary font-semibold ">
                    {planName}
                  </span>{" "} */}
                  order is now active. Get ready to streamline your hiring with
                  Reaidy.io!
                </p>
              </>
            }
            transactionId={transactionId}
            buttonText="View your Plan details"
            buttonClick={() => {
              if (role === "company") {
                navigate("/company/settings");
              } else {
                window.open("https://user.reaidy.io", "_self");
              }
            }}
            role={role}
          />
        ) : props.status === "failure" ? (
          <TransactionStatus
            status="failure"
            imageSrc={transactionFailed}
            paymentLink={paymentLink}
            title={<p className="text-red-500"> Transaction Failed! </p>}
            message={
              <>
                <p className="block tc1:hidden lg:block">
                  Your payment for{" "}
                  {/* <span className=" font-semibold ">{planName}</span> is */}
                  order is Unsuccessful! <br />
                  Please try again or contact support for assistance.
                </p>
                <p className="hidden tc1:block">
                  Your payment for{" "}
                  {/* <span className=" font-semibold ">{planName}</span> is */}
                  order is Unsuccessful! Please try again or contact support for
                  assistance.
                </p>
              </>
            }
            transactionId={transactionId}
            buttonText="Contact Support"
            buttonClick={() => {
              if (role === "company") {
                window.open("https://www.reaidy.io/contact", "_blank");
              } else {
                window.open(
                  "https://user.reaidy.io/dashboard/help?tab=report",
                  "_self"
                );
              }
            }}
            role={role}
          />
        ) : (
          <TransactionStatus
            status="pending"
            imageSrc={transactionPending}
            paymentLink={paymentLink}
            title={<p className="text-yellow"> Transaction Pending! </p>}
            message={
              <>
                <p className="block tc1:hidden lg:block">
                  Your payment for{" "}
                  {/* <span className="text-primary font-semibold">{planName}</span>{" "} */}
                  order is under review <br /> We'll update you once it's
                  completed.
                </p>
                <p className="hidden tc1:block">
                  Your payment for{" "}
                  {/* <span className="text-primary font-semibold">{planName}</span>{" "} */}
                  order is under review <br /> We'll update you once it's
                  completed.
                </p>
              </>
            }
            transactionId={transactionId}
            buttonText="Contact Support"
            buttonClick={() => {
              window.open("https://www.reaidy.io/contact", "_blank");
            }}
            role={role}
          />
        )}
      </div>
    </div>
  );
};

export default TransactionCards;
